import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { isMobile as isMobileCheck } from '@/helpers/mobile_detect';

export function useMobileDetect() {
  const isMobile = ref(isMobileCheck());

  function sync() {
    isMobile.value = isMobileCheck();
  }

  onMounted(() => $(document.body).on('resize:debounced', sync));

  onBeforeUnmount(() => $(document.body).off('resize:debounced', sync));

  return { isMobile };
}
